import { DateTime } from 'luxon';

// The max number of minutes to display.
export const MAX_MINUTES_TO_DISPLAY = 720;
export const WEEK_DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export function formatDateTime(dateTimeString: string, options: Intl.DateTimeFormatOptions = {}) {
  const date = DateTime.fromISO(dateTimeString);

  return date.setLocale('de-CH').toLocaleString(options);
}

type FormatDateRelativeOptions = {
  value: string;
  offsetSeconds?: number;
  format?: Intl.DateTimeFormatOptions;
  replace?: (date: string) => string;
};

const DEFAULT_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  hour: 'numeric',
  minute: 'numeric',
};

export function formatDateRelative({
  value,
  offsetSeconds = 0,
  format = DEFAULT_DATE_FORMAT,
  replace = (date: string) => date,
}: FormatDateRelativeOptions) {
  const locale = 'de-CH';

  const dateTime: DateTime = DateTime.fromISO(value);
  const offsetDateTime = dateTime.plus({ seconds: offsetSeconds });

  const formattedDate: string = offsetDateTime.toLocaleString(format, { locale });
  return replace ? replace(formattedDate) : formattedDate;
}

// Replace the weekday with "heute" or "morgen" if it's today or tomorrow.
export function replaceWithTodayAndTomorrow(formattedDate: string): string {
  const today = formatDateTime(DateTime.now().toString(), { weekday: 'long' });

  // Replace the weekday with "heute" if it's today.
  const replaced = formattedDate.replace(new RegExp(`^${today}`, 'i'), 'Heute');

  // Replace the weekday with "morgen" if it's tomorrow.
  const tomorrow = formatDateTime(DateTime.now().plus({ days: 1 }).toString(), { weekday: 'long' });
  return replaced.replace(new RegExp(`^${tomorrow}`, 'i'), 'Morgen');
}
